import React from "react";

class CarouselLoadingCompany extends React.Component {
  render() {
    return (
      <div className="carousel-loading">
        <div className="carousel-loading-item carousel-loading-item-1 company">
          <div className="carousel-loading-item--inner"></div>
          <div className="text-wrap">
            <p className="title">
              &nbsp;
              <span className="year">&nbsp;</span>
            </p>
          </div>
        </div>
        <div className="carousel-loading-item carousel-loading-item-2 company">
          <div className="carousel-loading-item--inner"></div>
          <div className="text-wrap">
            <p className="title">
              <span className="year"></span>
            </p>
          </div>
        </div>
        <div className="carousel-loading-item carousel-loading-item-3 company">
          <div className="carousel-loading-item--inner"></div>
          <div className="text-wrap">
            <p className="title">
              <span className="year"></span>
            </p>
          </div>
        </div>
        <div className="carousel-loading-item carousel-loading-item-4 company">
          <div className="carousel-loading-item--inner"></div>
          <div className="text-wrap">
            <p className="title">
              <span className="year"></span>
            </p>
          </div>
        </div>
        <div className="carousel-loading-item carousel-loading-item-5 company">
          <div className="carousel-loading-item--inner"></div>
          <div className="text-wrap">
            <p className="title">
              <span className="year"></span>
            </p>
          </div>
        </div>
        <div className="carousel-loading-item carousel-loading-item-6 company">
          <div className="carousel-loading-item--inner"></div>
          <div className="text-wrap">
            <p className="title">
              <span className="year"></span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default CarouselLoadingCompany;
